import {combineReducers} from 'redux'
import main from './reducer/main'

const rootRuducer = combineReducers({
    main: main
})


export default rootRuducer